<svg width="24" height="24" viewBox="0 0 24 24" class="icon-ctrl" [class.active]="isActive" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_2207_7706" fill="white">
        <rect x="5" y="5" width="6" height="6" rx="0.5"/>
    </mask>
    <rect x="5" y="5" width="6" height="6" rx="0.5" stroke="var(--bg-accent)" stroke-width="2" mask="url(#path-1-inside-1_2207_7706)"/>
    <mask id="path-2-inside-2_2207_7706" fill="white">
        <rect x="5" y="13" width="6" height="6" rx="0.5"/>
    </mask>
    <rect x="5" y="13" width="6" height="6" rx="0.5" stroke="var(--bg-accent)" stroke-width="2" mask="url(#path-2-inside-2_2207_7706)"/>
    <mask id="path-3-inside-3_2207_7706" fill="white">
        <rect x="13" y="5" width="6" height="6" rx="0.5"/>
    </mask>
    <rect x="13" y="5" width="6" height="6" rx="0.5" stroke="var(--bg-accent)" stroke-width="2" mask="url(#path-3-inside-3_2207_7706)"/>
    <rect x="15" y="15" width="2" height="4" rx="1" fill="var(--bg-accent)"/>
    <rect x="15" y="12" width="2" height="2" rx="1" fill="var(--bg-accent)"/>
</svg>
